export enum DeAddressVerificationResult {
  Failed = 'Failed',
  None = 'None',
  ServiceUnavailable = 'ServiceUnavailable',
  Success = 'Success'
}
